<template>
  <v-container class="py-0">
    <transition name="fade" mode="out-in" appear>
      <PageTitle class="d-block d-sm-none">Reports</PageTitle>
    </transition>

    <transition name="slide-left-fade" mode="out-in" appear>
      <v-tabs
        v-model="tab"
        class="mt-5 mt-sm-1"
        color="tabColor"
        slider-color="tabColor"
        center-active
        background-color="tertiary"
        show-arrows
        height="55"
      >
        <v-tab ripple>
          Deposits held 
        </v-tab>
        <v-tab ripple>
          Paid invoices
        </v-tab>
        <v-tab ripple>
          Unpaid invoices
        </v-tab>
        <v-tab ripple>
          Reconcile Report
        </v-tab>
        <v-spacer></v-spacer>
        <span class="d-none d-sm-block">
          <PageTitle>Reports</PageTitle>
        </span>
      </v-tabs>
    </transition>

    <transition name="slide-fade" mode="out-in" appear>
      <div>
        <v-tabs-items v-model="tab" class="pt-2 tertiary">
          <v-tab-item>
            <DepositsHeld :isLoading="depositsHeldLoading" />
          </v-tab-item> 
          <v-tab-item>
            <PaidInvoices :isLoading="paidInvoicesLoading" />
          </v-tab-item>
          <v-tab-item>
            <UnpaidInvoices :isLoading="unpaidInvoicesLoading" />
          </v-tab-item>
          <v-tab-item>
            <RStB :isLoading="rstbLoading" />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </transition>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import PaidInvoices from '@/components/ReportsTables/PaidInvoices'
import DepositsHeld from '@/components/ReportsTables/DepositsHeld'
import PageTitle from '@/components/Slots/PageTitle.vue'
import UnpaidInvoices from '@/components/ReportsTables/UnpaidInvoices'
import RStB from "@/components/ReportsTables/RStBTable"

export default {
  components: {
    PaidInvoices,
    DepositsHeld,
    PageTitle,
    UnpaidInvoices,
    RStB
  },
  created() {
    // Only load the first tab on initial load
    this.loadDepositsHeld()
    this.loadedTabs.depositsHeld = true
  },
  data() {
    return {
      tab: null,
      loadedTabs: {
        depositsHeld: false,
        paidInvoices: false,
        unpaidInvoices: false,
        rstb: false
      },
      currentDate: new Date().toISOString().substr(0, 7)
    }
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'depositsHeld',
        1: 'paidInvoices',
        2: 'unpaidInvoices',
        3: 'rstb'
      }
      
      const tabType = tabMap[newTab]
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadTabData(tabType)
        this.loadedTabs[tabType] = true
      }
    }
  },
  computed: {
    ...mapState({
      depositsHeldLoading: state => state.DepositsHeld.loading.accounts,
      paidInvoicesLoading: state => state.PaidInvoices.loading.invoices,
      unpaidInvoicesLoading: state => state.UnpaidInvoices.loading.invoices,
      rstbLoading: state => state.RStB.loading.report
    })
  },
  methods: {
    loadTabData(tabType) {
      switch(tabType) {
        case 'depositsHeld':
          this.loadDepositsHeld()
          break
        case 'paidInvoices':
          this.loadPaidInvoices()
          break
        case 'unpaidInvoices':
          this.loadUnpaidInvoices()
          break
        case 'rstb':
          this.loadRStB()
          break
      }
    },
    async loadDepositsHeld() {
      await this.$store.dispatch('DepositsHeld/getAccounts', this.currentDate)
    },
    async loadPaidInvoices() {
      await this.$store.dispatch('PaidInvoices/getPaidInvoices', this.currentDate)
    },
    async loadUnpaidInvoices() {
      await this.$store.dispatch('UnpaidInvoices/getUnpaidInvoices', this.currentDate)
    },
    async loadRStB() {
      await this.$store.dispatch('RStB/getRStB', this.currentDate)
    }
  }
}
</script>

<style>

</style>